import React, { memo } from "react";
import { Modal, Button } from "react-bootstrap";

const BootstrapModal = memo(
  ({ status, toggle, message, data }) => {

    return (
      <Modal show={status}
      onHide={toggle} size="lg" centered>
      <Modal.Header className="d-flex">
        <Modal.Title className="text-translation popup_heading m-0">
          VIP Video
        </Modal.Title>

        <Button
          variant="link"
          className="modalClose-Btn p-0"
          onClick={toggle}
          style={{top: "18px"}}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>        

        <Modal.Body className="p-0">
          {message && <h6>{message}</h6>}
          {data && (
            <div className="modal-content-height text-center">
              {data}
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  }
);

export default BootstrapModal;